import { KTIcon } from "../../../../../../_metronic/helpers";

const GateListModalHeader = ({
  listing,
  setOpenGateListModal,
  setOpenTimelineModal
}) => {
  return (
    <div className="modal-header">
      {/* begin::Modal title */}
      <div className="d-flex flex-column">
      <h2 className="fw-bolder listing_title">Gate List for <span className="fw-bolder text-main">{listing.title}</span></h2>
      </div>
      {/* end::Modal title */}
      <div
        className="btn btn-icon btn-sm btn-active-icon-primary align-items-start align-self-start"
        data-kt-users-modal-action="close"
        onClick={() => {
          setOpenGateListModal(false)
          setOpenTimelineModal(false)
        }}
        style={{ cursor: "pointer" }}
      >
        <KTIcon iconName="cross" className="fs-1" />
      </div>
    </div>
  );
};

export { GateListModalHeader };
